import getWorkoutSectionsWorkoutUtil from '../../../../../modules/workout/model/utils/get-workout-sections'
import { setIdReduxAction } from '../../../../redux/actions/set-id'
import { getActionStrReduxUtil } from '../../../../redux/utils/get-action-str'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import updateCurrentWorkoutSectionAction from '../../../../workout-section/redux/actions/update-current'
import WORKOUTS_ACTION from '../../constants/action'
import WORKOUTS_PATH from '../../constants/path'
import getByIdWorkoutSelector from '../../selectors/get-by-id'

function updateCurrentWorkoutAction (instanceOrId) {
  return (dispatch, getState) => {
    let instance
    if (typeof instanceOrId === 'number') {
      instance = getByIdWorkoutSelector(instanceOrId)(getState())
    } else {
      instance = instanceOrId
    }

    const id = getIdReduxUtil(instance)
    dispatch(setIdReduxAction({
      type: getActionStrReduxUtil(WORKOUTS_ACTION.UPDATE_CURRENT, id),
      payload: {
        path: WORKOUTS_PATH.CURRENT,
        id
      }
    }))

    if (instance) {
      const firstWorkoutSection = getWorkoutSectionsWorkoutUtil(instance)[0]
      dispatch(updateCurrentWorkoutSectionAction(getIdReduxUtil(
        firstWorkoutSection)))
    }

    return instance
  }
}

export default updateCurrentWorkoutAction
